import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f9f11e30")
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "swiper-wrapper h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
_popScopeId()

import { onMounted } from 'vue';
import Swiper from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core';
import 'swiper/swiper-bundle.css';

type Props = { height: string };
import 'swiper/components/pagination/pagination.min.css';

export default _defineComponent({
  props: {
    height: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: { height: string }) {



// modules styles
SwiperCore.use([Pagination]);

onMounted(() => {
  new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: -5,

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="${className} bal-bullet"></span>`;
      }
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`swiper-container h-${__props.height}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$slots.default(), (child, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "swiper-slide h-full pr-4",
            key: `slide-${i}`
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(child)))
          ]))
        }), 128))
      ])
    ], 2),
    _hoisted_3
  ]))
}
}

})